import { useEffect, useRef } from "react";

/**
 * useClickOutside(ref, handler)
 *
 * Calls `handler` whenever a mousedown event fires outside the element
 * pointed to by `ref`. The handler is always up-to-date without needing
 * to be listed as a dep (stored in a ref internally).
 */
export function useClickOutside(ref, handler) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    function onMouseDown(e) {
      if (!ref.current?.contains(e.target)) handlerRef.current();
    }
    document.addEventListener("mousedown", onMouseDown);
    return () => document.removeEventListener("mousedown", onMouseDown);
  }, [ref]);
}
